import 'reflect-metadata';
import {
  Expose,
  plainToInstance,
  instanceToPlain,
  Type,
} from 'class-transformer';

export class StoryVideo {
  id: number;

  title: string;

  description: string;

  url: string;

  @Expose({ name: 'updated_at' })
  @Type(() => Date)
  updatedAt?: Date;

  constructor(
    id: number,
    title: string,
    description: string,
    url: string,
    updatedAt?: Date
  ) {
    this.id = id;
    this.title = title;
    this.description = description;
    this.url = url;
    this.updatedAt = updatedAt;
  }

  static fromJson(json: Record<string, any>): StoryVideo {
    return plainToInstance(StoryVideo, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}
